<template>
  <div class="mapSync">
    <span v-if="!isPresenting && boardData.sync">Moderation: <b>{{boardData.user}}</b></span>
    <div v-if="isPresenting && boardData.sync" style="display:inline-block; margin-right: 10px;">
      <button class="btn--icon btn--subtile btn--subtileround">
        <svgicon icon="microphone" width="32" height="32" color="#000000"></svgicon>
      </button>
      <button class="btn--icon btn--subtile btn--subtileround">
        <svgicon icon="webcam" width="32" height="32" color="#000000"></svgicon>
      </button>
    </div>
    <button @click="$emit('toggleSync')" class="btn--icon" v-bind:class="{ 'btn--subtile': !isPresenting }">
      <svgicon icon="present" width="32" height="32" color="#000000"></svgicon>
    </button>
  </div>
</template>

<script>

import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'

export default {
  name: 'MapSync',
  props: ['share', 'boardData', 'session'],
  updated () {
    if (this.boardData.sync) {
      this.parentContainer = findRealParent(this.$parent)
      this.parentContainer.mapObject.setView(this.boardData.position, this.boardData.zoom)
    }
  },
  computed: {
    // a computed getter
    isPresenting: function () {
      if (this.boardData.sync === true && this.session === this.boardData.session) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .btn--subtileround {
    border-radius: 50% !important;
    box-shadow: none !important;
    margin-left: 5px;
    svg {
      // opacity: 0.25 !important;
    }
    svg path {
      fill: $color-action !important;
    }
  }
  .mapSync {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9999;
    font-size:$font-size-small;
  }

  .mapSync button {
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
    background-color: $color-error !important;
    transition: border-radius 0.3s ease;
  }

  .mapSync span {
    padding: 0px 15px;
    line-height: 46px;
    display: inline-block;
    background-color: rgba(255,255,255,0.4);
    color: $color-error;
    // font-weight: bold;
    margin-right: -2px;
    margin-top: -1px;
  }

  .mapSync button:not(.btn--subtile) {
    box-shadow: 0 0 0 rgba(204,169,44, 0.4);
    animation: pulse 2s infinite;
    border-radius: 50%;
  }

  .mapSync .btn--subtile {
    background: #fff !important;

    svg path {
      fill: $color-error;
    }
  }

  @-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba($color-error, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba($color-error, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba($color-error, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba($color-error, 0.4);
    box-shadow: 0 0 0 0 rgba($color-error, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba($color-error, 0);
      box-shadow: 0 0 0 10px rgba($color-error, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba($color-error, 0);
      box-shadow: 0 0 0 0 rgba($color-error, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapSync.vue